/* ZSportsTech — section-nspkg.js
   Step 1 of the Net Sessions flow: BUY. Packages are Shopify products, so this
   just adds the right variant to the cart and hands off to Shopify checkout.
   Payment, receipts and refunds are Shopify's problem.

   Guests may buy. Signing in is what ACTIVATES the sessions afterwards — see
   section-mysess.js, which calls `sync` to turn paid orders into packages.

   Each "Book →" link keeps its href="#sc-ns-enquiry" so that if the variant is
   missing (product unpublished) or JS fails, the click still lands on the
   enquiry form, exactly as it did before any of this existed.
   ─────────────────────────────────────────────────── */
(function () {
  'use strict';

  var links = document.querySelectorAll('[data-ns-variant]');
  if (!links.length) return;

  var cfg = window.SC_NS_CONFIG || {};

  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var variantId = link.getAttribute('data-ns-variant');
      if (!variantId) return;             // no variant → fall through to the enquiry anchor

      /* Net-session packages are a TRACKABLE balance keyed to the customer's
         account, so purchase requires sign-in. Links flagged data-ns-login-required
         (the package rows) redirect a signed-out visitor to login first; the
         clinic's fallback links are not flagged and stay guest-friendly. */
      if (link.hasAttribute('data-ns-login-required') && !(cfg.customer && cfg.customer.email)) {
        e.preventDefault();
        window.location.assign(cfg.loginUrl || '/account/login');
        return;
      }

      e.preventDefault();
      buy(link, variantId);
    });
  });

  function buy(link, variantId) {
    if (link.dataset.busy) return;
    link.dataset.busy = '1';
    var original = link.textContent;
    link.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(t.slice(0, 200)); });
      /* Straight to checkout — the packages are the whole purchase, and mixing
         them into the cart drawer would bury the call to action. */
      window.location.assign('/checkout');
    }).catch(function (err) {
      link.dataset.busy = '';
      link.textContent = original;
      /* Most likely cause: the product is not published to the Online Store,
         so Shopify refuses the variant. Say something true rather than nothing. */
      console.error('[net-sessions] cart/add failed:', err);
      showError('Sorry, we could not start checkout for that package. Please try again, or use the enquiry form below.');
    });
  }

  function showError(msg) {
    var box = document.querySelector('[data-ns-msg]');
    if (!box) { window.location.hash = '#sc-ns-enquiry'; return; }
    box.textContent = msg;
    box.hidden = false;
  }
}());
